/**
 * De ene bewegingscurve van het merk ("ease-soft"). Dezelfde waarde staat als
 * `ease-soft` in tailwind.config.js voor CSS-transities — pas ze samen aan.
 */
export const ease = [0.23, 1, 0.32, 1] as const

/** Dezelfde curve als CSS-string, voor inline `transition`. */
export const easeCss = 'cubic-bezier(0.23, 1, 0.32, 1)'
